const shadows = [
  'none',
  '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
  '0px 1px 3px 0px rgba(0, 0, 0, 0.06), 0px 1px 2px 0px rgba(0, 0, 0, 0.04)',
  '0px 4px 6px -1px rgba(0, 0, 0, 0.07), 0px 2px 4px -1px rgba(0, 0, 0, 0.04)',
  '0px 6px 10px -2px rgba(0, 0, 0, 0.07), 0px 3px 6px -2px rgba(0, 0, 0, 0.04)',
  '0px 8px 14px -3px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.04)',
  '0px 10px 15px -3px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.04)',
  '0px 12px 18px -4px rgba(0, 0, 0, 0.09), 0px 5px 8px -3px rgba(0, 0, 0, 0.04)',
  '0px 14px 20px -4px rgba(0, 0, 0, 0.08), 0px 6px 10px -3px rgba(0, 0, 0, 0.03)',
  '0px 16px 24px -4px rgba(0, 0, 0, 0.09), 0px 6px 12px -3px rgba(0, 0, 0, 0.04)',
  '0px 18px 28px -5px rgba(0, 0, 0, 0.10), 0px 8px 14px -4px rgba(0, 0, 0, 0.04)',
  '0px 20px 32px -6px rgba(0, 0, 0, 0.10), 0px 8px 16px -4px rgba(0, 0, 0, 0.04)',
  '0px 22px 36px -6px rgba(0, 0, 0, 0.11), 0px 10px 18px -5px rgba(0, 0, 0, 0.05)',
  '0px 24px 38px -7px rgba(0, 0, 0, 0.11), 0px 10px 20px -5px rgba(0, 0, 0, 0.05)',
  '0px 26px 42px -8px rgba(0, 0, 0, 0.12), 0px 12px 22px -6px rgba(0, 0, 0, 0.05)',
  '0px 28px 46px -8px rgba(0, 0, 0, 0.12), 0px 12px 24px -6px rgba(0, 0, 0, 0.05)',
  '0px 30px 50px -9px rgba(0, 0, 0, 0.13), 0px 14px 26px -7px rgba(0, 0, 0, 0.06)',
  '0px 32px 54px -10px rgba(0, 0, 0, 0.13), 0px 14px 28px -7px rgba(0, 0, 0, 0.06)',
  '0px 34px 58px -10px rgba(0, 0, 0, 0.14), 0px 16px 30px -8px rgba(0, 0, 0, 0.06)',
  '0px 36px 62px -11px rgba(0, 0, 0, 0.14), 0px 16px 32px -8px rgba(0, 0, 0, 0.06)',
  '0px 38px 66px -12px rgba(0, 0, 0, 0.15), 0px 18px 34px -9px rgba(0, 0, 0, 0.07)',
  '0px 40px 70px -12px rgba(0, 0, 0, 0.15), 0px 18px 36px -9px rgba(0, 0, 0, 0.07)',
  '0px 42px 74px -13px rgba(0, 0, 0, 0.16), 0px 20px 38px -10px rgba(0, 0, 0, 0.07)',
  '0px 44px 78px -14px rgba(0, 0, 0, 0.16), 0px 20px 40px -10px rgba(0, 0, 0, 0.07)',
  '0px 48px 84px -15px rgba(0, 0, 0, 0.17), 0px 24px 44px -12px rgba(0, 0, 0, 0.08)',
];

const darkshadows = [
  'none',
  '0px 1px 2px 0px rgba(0, 0, 0, 0.35)',
  '0px 1px 3px 0px rgba(0, 0, 0, 0.40), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)',
  '0px 4px 6px -1px rgba(0, 0, 0, 0.45), 0px 2px 4px -1px rgba(0, 0, 0, 0.35)',
  '0px 6px 10px -2px rgba(0, 0, 0, 0.50), 0px 3px 6px -2px rgba(0, 0, 0, 0.35)',
  '0px 8px 14px -3px rgba(0, 0, 0, 0.55), 0px 4px 6px -2px rgba(0, 0, 0, 0.40)',
  '0px 10px 15px -3px rgba(0, 0, 0, 0.55), 0px 4px 6px -2px rgba(0, 0, 0, 0.40)',
  '0px 12px 18px -4px rgba(0, 0, 0, 0.60), 0px 5px 8px -3px rgba(0, 0, 0, 0.45)',
  '0px 14px 20px -4px rgba(0, 0, 0, 0.60), 0px 6px 10px -3px rgba(0, 0, 0, 0.45)',
  '0px 16px 24px -4px rgba(0, 0, 0, 0.65), 0px 6px 12px -3px rgba(0, 0, 0, 0.50)',
  '0px 18px 28px -5px rgba(0, 0, 0, 0.65), 0px 8px 14px -4px rgba(0, 0, 0, 0.50)',
  '0px 20px 32px -6px rgba(0, 0, 0, 0.70), 0px 8px 16px -4px rgba(0, 0, 0, 0.50)',
  '0px 22px 36px -6px rgba(0, 0, 0, 0.70), 0px 10px 18px -5px rgba(0, 0, 0, 0.55)',
  '0px 24px 38px -7px rgba(0, 0, 0, 0.75), 0px 10px 20px -5px rgba(0, 0, 0, 0.55)',
  '0px 26px 42px -8px rgba(0, 0, 0, 0.75), 0px 12px 22px -6px rgba(0, 0, 0, 0.60)',
  '0px 28px 46px -8px rgba(0, 0, 0, 0.80), 0px 12px 24px -6px rgba(0, 0, 0, 0.60)',
  '0px 30px 50px -9px rgba(0, 0, 0, 0.80), 0px 14px 26px -7px rgba(0, 0, 0, 0.65)',
  '0px 32px 54px -10px rgba(0, 0, 0, 0.85), 0px 14px 28px -7px rgba(0, 0, 0, 0.65)',
  '0px 34px 58px -10px rgba(0, 0, 0, 0.85), 0px 16px 30px -8px rgba(0, 0, 0, 0.70)',
  '0px 36px 62px -11px rgba(0, 0, 0, 0.90), 0px 16px 32px -8px rgba(0, 0, 0, 0.70)',
  '0px 38px 66px -12px rgba(0, 0, 0, 0.90), 0px 18px 34px -9px rgba(0, 0, 0, 0.75)',
  '0px 40px 70px -12px rgba(0, 0, 0, 0.92), 0px 18px 36px -9px rgba(0, 0, 0, 0.75)',
  '0px 42px 74px -13px rgba(0, 0, 0, 0.94), 0px 20px 38px -10px rgba(0, 0, 0, 0.80)',
  '0px 44px 78px -14px rgba(0, 0, 0, 0.95), 0px 20px 40px -10px rgba(0, 0, 0, 0.80)',
  '0px 48px 84px -15px rgba(0, 0, 0, 0.98), 0px 24px 44px -12px rgba(0, 0, 0, 0.85)',
];

export { shadows, darkshadows };
